import Service from '@ember/service';
import { service } from '@ember/service';
import type AditoolsSiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type { SimDDSSiteConfigData } from 'simdds';
import type LoggingService from './logger';

export default class FeedbackService extends Service {
  @service('aditools-site') declare siteconfig: AditoolsSiteService & SimDDSSiteConfigData;
  @service declare logger: LoggingService;
  deliverFeedback(name: string, email: string, feedback: string): Promise<{ status: number }> {
    const siteconfig = this.siteconfig;
    const feedbackData = {
      ToolId: 4,
      Name: encodeURIComponent(name),
      Email: encodeURIComponent(email),
      Feedback: encodeURIComponent(feedback),
    };
    return fetch(`${siteconfig.ApiUrl}/feedback/${siteconfig.AdiLocale}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(feedbackData),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        this.logger.error(`Give feedback failed: ${error}`);
        return { status: -1 };
      });
  }
}

declare module '@ember/service' {
  interface Registry {
    feedback: FeedbackService;
  }
}
